/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardUsageRouteImport } from './routes/dashboard/usage'
import { Route as DashboardTeacherTestResultRouteImport } from './routes/dashboard/teacher-test-result'
import { Route as DashboardTeacherSurveyRouteImport } from './routes/dashboard/teacher-survey'
import { Route as DashboardTeacherQuizzesRouteImport } from './routes/dashboard/teacher-quizzes'
import { Route as DashboardTeacherFeedbackRouteImport } from './routes/dashboard/teacher-feedback'
import { Route as DashboardSummaryRouteImport } from './routes/dashboard/summary'
import { Route as DashboardResourcesRouteImport } from './routes/dashboard/resources'
import { Route as DashboardRecordingsRouteImport } from './routes/dashboard/recordings'
import { Route as DashboardQuizBusinessRouteImport } from './routes/dashboard/quiz-business'
import { Route as DashboardPerformanceRouteImport } from './routes/dashboard/performance'
import { Route as DashboardFeedbackRouteImport } from './routes/dashboard/feedback'
import { Route as DashboardAiFeedbackRouteImport } from './routes/dashboard/ai-feedback'
import { Route as DashboardProfileRouteRouteImport } from './routes/dashboard/profile/route'
import { Route as DashboardProfileIndexRouteImport } from './routes/dashboard/profile/index'
import { Route as DashboardProfilePreferredAccentRouteImport } from './routes/dashboard/profile/preferred-accent'
import { Route as DashboardProfilePersonalInformationRouteImport } from './routes/dashboard/profile/personal-information'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardUsageRoute = DashboardUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTeacherTestResultRoute =
  DashboardTeacherTestResultRouteImport.update({
    id: '/teacher-test-result',
    path: '/teacher-test-result',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardTeacherSurveyRoute = DashboardTeacherSurveyRouteImport.update({
  id: '/teacher-survey',
  path: '/teacher-survey',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTeacherQuizzesRoute = DashboardTeacherQuizzesRouteImport.update({
  id: '/teacher-quizzes',
  path: '/teacher-quizzes',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTeacherFeedbackRoute =
  DashboardTeacherFeedbackRouteImport.update({
    id: '/teacher-feedback',
    path: '/teacher-feedback',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSummaryRoute = DashboardSummaryRouteImport.update({
  id: '/summary',
  path: '/summary',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardResourcesRoute = DashboardResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardRecordingsRoute = DashboardRecordingsRouteImport.update({
  id: '/recordings',
  path: '/recordings',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardQuizBusinessRoute = DashboardQuizBusinessRouteImport.update({
  id: '/quiz-business',
  path: '/quiz-business',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPerformanceRoute = DashboardPerformanceRouteImport.update({
  id: '/performance',
  path: '/performance',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardFeedbackRoute = DashboardFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAiFeedbackRoute = DashboardAiFeedbackRouteImport.update({
  id: '/ai-feedback',
  path: '/ai-feedback',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardProfileRouteRoute = DashboardProfileRouteRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardProfileIndexRoute = DashboardProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardProfileRouteRoute,
} as any)
const DashboardProfilePreferredAccentRoute =
  DashboardProfilePreferredAccentRouteImport.update({
    id: '/preferred-accent',
    path: '/preferred-accent',
    getParentRoute: () => DashboardProfileRouteRoute,
  } as any)
const DashboardProfilePersonalInformationRoute =
  DashboardProfilePersonalInformationRouteImport.update({
    id: '/personal-information',
    path: '/personal-information',
    getParentRoute: () => DashboardProfileRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/dashboard/profile': typeof DashboardProfileRouteRouteWithChildren
  '/dashboard/ai-feedback': typeof DashboardAiFeedbackRoute
  '/dashboard/feedback': typeof DashboardFeedbackRoute
  '/dashboard/performance': typeof DashboardPerformanceRoute
  '/dashboard/quiz-business': typeof DashboardQuizBusinessRoute
  '/dashboard/recordings': typeof DashboardRecordingsRoute
  '/dashboard/resources': typeof DashboardResourcesRoute
  '/dashboard/summary': typeof DashboardSummaryRoute
  '/dashboard/teacher-feedback': typeof DashboardTeacherFeedbackRoute
  '/dashboard/teacher-quizzes': typeof DashboardTeacherQuizzesRoute
  '/dashboard/teacher-survey': typeof DashboardTeacherSurveyRoute
  '/dashboard/teacher-test-result': typeof DashboardTeacherTestResultRoute
  '/dashboard/usage': typeof DashboardUsageRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/profile/personal-information': typeof DashboardProfilePersonalInformationRoute
  '/dashboard/profile/preferred-accent': typeof DashboardProfilePreferredAccentRoute
  '/dashboard/profile/': typeof DashboardProfileIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard/ai-feedback': typeof DashboardAiFeedbackRoute
  '/dashboard/feedback': typeof DashboardFeedbackRoute
  '/dashboard/performance': typeof DashboardPerformanceRoute
  '/dashboard/quiz-business': typeof DashboardQuizBusinessRoute
  '/dashboard/recordings': typeof DashboardRecordingsRoute
  '/dashboard/resources': typeof DashboardResourcesRoute
  '/dashboard/summary': typeof DashboardSummaryRoute
  '/dashboard/teacher-feedback': typeof DashboardTeacherFeedbackRoute
  '/dashboard/teacher-quizzes': typeof DashboardTeacherQuizzesRoute
  '/dashboard/teacher-survey': typeof DashboardTeacherSurveyRoute
  '/dashboard/teacher-test-result': typeof DashboardTeacherTestResultRoute
  '/dashboard/usage': typeof DashboardUsageRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/profile/personal-information': typeof DashboardProfilePersonalInformationRoute
  '/dashboard/profile/preferred-accent': typeof DashboardProfilePreferredAccentRoute
  '/dashboard/profile': typeof DashboardProfileIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/dashboard/profile': typeof DashboardProfileRouteRouteWithChildren
  '/dashboard/ai-feedback': typeof DashboardAiFeedbackRoute
  '/dashboard/feedback': typeof DashboardFeedbackRoute
  '/dashboard/performance': typeof DashboardPerformanceRoute
  '/dashboard/quiz-business': typeof DashboardQuizBusinessRoute
  '/dashboard/recordings': typeof DashboardRecordingsRoute
  '/dashboard/resources': typeof DashboardResourcesRoute
  '/dashboard/summary': typeof DashboardSummaryRoute
  '/dashboard/teacher-feedback': typeof DashboardTeacherFeedbackRoute
  '/dashboard/teacher-quizzes': typeof DashboardTeacherQuizzesRoute
  '/dashboard/teacher-survey': typeof DashboardTeacherSurveyRoute
  '/dashboard/teacher-test-result': typeof DashboardTeacherTestResultRoute
  '/dashboard/usage': typeof DashboardUsageRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/profile/personal-information': typeof DashboardProfilePersonalInformationRoute
  '/dashboard/profile/preferred-accent': typeof DashboardProfilePreferredAccentRoute
  '/dashboard/profile/': typeof DashboardProfileIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/login'
    | '/dashboard/profile'
    | '/dashboard/ai-feedback'
    | '/dashboard/feedback'
    | '/dashboard/performance'
    | '/dashboard/quiz-business'
    | '/dashboard/recordings'
    | '/dashboard/resources'
    | '/dashboard/summary'
    | '/dashboard/teacher-feedback'
    | '/dashboard/teacher-quizzes'
    | '/dashboard/teacher-survey'
    | '/dashboard/teacher-test-result'
    | '/dashboard/usage'
    | '/dashboard/'
    | '/dashboard/profile/personal-information'
    | '/dashboard/profile/preferred-accent'
    | '/dashboard/profile/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/dashboard/ai-feedback'
    | '/dashboard/feedback'
    | '/dashboard/performance'
    | '/dashboard/quiz-business'
    | '/dashboard/recordings'
    | '/dashboard/resources'
    | '/dashboard/summary'
    | '/dashboard/teacher-feedback'
    | '/dashboard/teacher-quizzes'
    | '/dashboard/teacher-survey'
    | '/dashboard/teacher-test-result'
    | '/dashboard/usage'
    | '/dashboard'
    | '/dashboard/profile/personal-information'
    | '/dashboard/profile/preferred-accent'
    | '/dashboard/profile'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/login'
    | '/dashboard/profile'
    | '/dashboard/ai-feedback'
    | '/dashboard/feedback'
    | '/dashboard/performance'
    | '/dashboard/quiz-business'
    | '/dashboard/recordings'
    | '/dashboard/resources'
    | '/dashboard/summary'
    | '/dashboard/teacher-feedback'
    | '/dashboard/teacher-quizzes'
    | '/dashboard/teacher-survey'
    | '/dashboard/teacher-test-result'
    | '/dashboard/usage'
    | '/dashboard/'
    | '/dashboard/profile/personal-information'
    | '/dashboard/profile/preferred-accent'
    | '/dashboard/profile/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/usage': {
      id: '/dashboard/usage'
      path: '/usage'
      fullPath: '/dashboard/usage'
      preLoaderRoute: typeof DashboardUsageRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/teacher-test-result': {
      id: '/dashboard/teacher-test-result'
      path: '/teacher-test-result'
      fullPath: '/dashboard/teacher-test-result'
      preLoaderRoute: typeof DashboardTeacherTestResultRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/teacher-survey': {
      id: '/dashboard/teacher-survey'
      path: '/teacher-survey'
      fullPath: '/dashboard/teacher-survey'
      preLoaderRoute: typeof DashboardTeacherSurveyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/teacher-quizzes': {
      id: '/dashboard/teacher-quizzes'
      path: '/teacher-quizzes'
      fullPath: '/dashboard/teacher-quizzes'
      preLoaderRoute: typeof DashboardTeacherQuizzesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/teacher-feedback': {
      id: '/dashboard/teacher-feedback'
      path: '/teacher-feedback'
      fullPath: '/dashboard/teacher-feedback'
      preLoaderRoute: typeof DashboardTeacherFeedbackRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/summary': {
      id: '/dashboard/summary'
      path: '/summary'
      fullPath: '/dashboard/summary'
      preLoaderRoute: typeof DashboardSummaryRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/resources': {
      id: '/dashboard/resources'
      path: '/resources'
      fullPath: '/dashboard/resources'
      preLoaderRoute: typeof DashboardResourcesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/recordings': {
      id: '/dashboard/recordings'
      path: '/recordings'
      fullPath: '/dashboard/recordings'
      preLoaderRoute: typeof DashboardRecordingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/quiz-business': {
      id: '/dashboard/quiz-business'
      path: '/quiz-business'
      fullPath: '/dashboard/quiz-business'
      preLoaderRoute: typeof DashboardQuizBusinessRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/performance': {
      id: '/dashboard/performance'
      path: '/performance'
      fullPath: '/dashboard/performance'
      preLoaderRoute: typeof DashboardPerformanceRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/feedback': {
      id: '/dashboard/feedback'
      path: '/feedback'
      fullPath: '/dashboard/feedback'
      preLoaderRoute: typeof DashboardFeedbackRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/ai-feedback': {
      id: '/dashboard/ai-feedback'
      path: '/ai-feedback'
      fullPath: '/dashboard/ai-feedback'
      preLoaderRoute: typeof DashboardAiFeedbackRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/profile': {
      id: '/dashboard/profile'
      path: '/profile'
      fullPath: '/dashboard/profile'
      preLoaderRoute: typeof DashboardProfileRouteRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/profile/': {
      id: '/dashboard/profile/'
      path: '/'
      fullPath: '/dashboard/profile/'
      preLoaderRoute: typeof DashboardProfileIndexRouteImport
      parentRoute: typeof DashboardProfileRouteRoute
    }
    '/dashboard/profile/preferred-accent': {
      id: '/dashboard/profile/preferred-accent'
      path: '/preferred-accent'
      fullPath: '/dashboard/profile/preferred-accent'
      preLoaderRoute: typeof DashboardProfilePreferredAccentRouteImport
      parentRoute: typeof DashboardProfileRouteRoute
    }
    '/dashboard/profile/personal-information': {
      id: '/dashboard/profile/personal-information'
      path: '/personal-information'
      fullPath: '/dashboard/profile/personal-information'
      preLoaderRoute: typeof DashboardProfilePersonalInformationRouteImport
      parentRoute: typeof DashboardProfileRouteRoute
    }
  }
}

interface DashboardProfileRouteRouteChildren {
  DashboardProfilePersonalInformationRoute: typeof DashboardProfilePersonalInformationRoute
  DashboardProfilePreferredAccentRoute: typeof DashboardProfilePreferredAccentRoute
  DashboardProfileIndexRoute: typeof DashboardProfileIndexRoute
}

const DashboardProfileRouteRouteChildren: DashboardProfileRouteRouteChildren = {
  DashboardProfilePersonalInformationRoute:
    DashboardProfilePersonalInformationRoute,
  DashboardProfilePreferredAccentRoute: DashboardProfilePreferredAccentRoute,
  DashboardProfileIndexRoute: DashboardProfileIndexRoute,
}

const DashboardProfileRouteRouteWithChildren =
  DashboardProfileRouteRoute._addFileChildren(
    DashboardProfileRouteRouteChildren,
  )

interface DashboardRouteChildren {
  DashboardProfileRouteRoute: typeof DashboardProfileRouteRouteWithChildren
  DashboardAiFeedbackRoute: typeof DashboardAiFeedbackRoute
  DashboardFeedbackRoute: typeof DashboardFeedbackRoute
  DashboardPerformanceRoute: typeof DashboardPerformanceRoute
  DashboardQuizBusinessRoute: typeof DashboardQuizBusinessRoute
  DashboardRecordingsRoute: typeof DashboardRecordingsRoute
  DashboardResourcesRoute: typeof DashboardResourcesRoute
  DashboardSummaryRoute: typeof DashboardSummaryRoute
  DashboardTeacherFeedbackRoute: typeof DashboardTeacherFeedbackRoute
  DashboardTeacherQuizzesRoute: typeof DashboardTeacherQuizzesRoute
  DashboardTeacherSurveyRoute: typeof DashboardTeacherSurveyRoute
  DashboardTeacherTestResultRoute: typeof DashboardTeacherTestResultRoute
  DashboardUsageRoute: typeof DashboardUsageRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardProfileRouteRoute: DashboardProfileRouteRouteWithChildren,
  DashboardAiFeedbackRoute: DashboardAiFeedbackRoute,
  DashboardFeedbackRoute: DashboardFeedbackRoute,
  DashboardPerformanceRoute: DashboardPerformanceRoute,
  DashboardQuizBusinessRoute: DashboardQuizBusinessRoute,
  DashboardRecordingsRoute: DashboardRecordingsRoute,
  DashboardResourcesRoute: DashboardResourcesRoute,
  DashboardSummaryRoute: DashboardSummaryRoute,
  DashboardTeacherFeedbackRoute: DashboardTeacherFeedbackRoute,
  DashboardTeacherQuizzesRoute: DashboardTeacherQuizzesRoute,
  DashboardTeacherSurveyRoute: DashboardTeacherSurveyRoute,
  DashboardTeacherTestResultRoute: DashboardTeacherTestResultRoute,
  DashboardUsageRoute: DashboardUsageRoute,
  DashboardIndexRoute: DashboardIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
